module.exports = __webpack_public_path__ + "static/img/A (23).361789f8.png";